import { Component, ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

interface Props { children: ReactNode; fallback?: ReactNode }
interface State { hasError: boolean; message?: string }

/** Catches scanner runtime crashes so the manual-code fallback always renders. */
export class ScanErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message };
  }

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error("[Scan] viewport crashed", error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div data-testid="scan-error-boundary"
          className="border border-oxblood/30 bg-oxblood/5 px-4 py-3 text-sm text-oxblood-deep flex items-start gap-2">
          <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
          <span>
            The camera viewport hit a snag. The manual code field below still works.
            {this.state.message ? <em className="block text-[11px] opacity-80 mt-1">{this.state.message}</em> : null}
          </span>
        </div>
      );
    }
    return this.props.children;
  }
}
